/**
 * SSE reconnect timing for blue-green cutover and ordinary stream recycle.
 *
 * Apache restart is about a 1s blip. The live-connection banner waits 2.5s, so
 * the first retries must land well under that or every ship shows "Reconnecting".
 */

/** Clean close (including GOAWAY) — retry before the reconnecting banner delay. */
export const HUB_STREAM_CLEAN_CLOSE_RECONNECT_MS = 250;

const TRANSPORT_RETRY_MS = [250, 250, 500, 1_000, 5_000] as const;

/** Backoff for fetch/SSE transport failures. `consecutiveFailures` is 1-based after increment. */
export function hubStreamTransportReconnectMs(consecutiveFailures: number): number {
  if (consecutiveFailures < 1) {
    return TRANSPORT_RETRY_MS[0];
  }
  const index = Math.min(consecutiveFailures, TRANSPORT_RETRY_MS.length) - 1;
  return TRANSPORT_RETRY_MS[index];
}
